export class AppSettings {
	analyticsEndpoint: string = '';
  loggingEndpoint: string = ''
}

export class AppConfig {
	constructor(public appSettings: AppSettings = new AppSettings()) {}
}
